module.exports = __webpack_public_path__ + "static/media/audioload.493f10da.gif";